module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/downloadH5-8d22061adf8a8bc21447492d3e0050c4.png";